/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Get_HelpInputs */

const en_mobile_get_help = /** @type {(inputs: Mobile_Get_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Help`)
};

const es_mobile_get_help = /** @type {(inputs: Mobile_Get_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtener ayuda`)
};

/**
* | output |
* | --- |
* | "Get Help" |
*
* @param {Mobile_Get_HelpInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_get_help = /** @type {((inputs?: Mobile_Get_HelpInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Get_HelpInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_get_help(inputs)
	return en_mobile_get_help(inputs)
});